import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'grid-specs',
  templateUrl: './grid-specs.component.html',
  styleUrls: ['./grid-specs.component.sass']
})
export class GridSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/datagrid/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
